export const apiUrl = "https://js-architekturfotografie.ch/api";